import Role from "./Role.js";

/**
 * `agencyRole` describes permissions of agency users such as
 * consultant and directors.
 *
 * @abstract
 * @param {string[]} spec.companyIds - Identifiers of companies the role is bound to
 */
export default class AgencyRole extends Role {
	constructor({ companyIds } = {}) {
		super(...arguments);
		this._companyIds = companyIds;
	}

	//
	// canDelete
	//

	canBeDeletedByCountryUser() {
		return true;
	}

	canBeDeletedByDirector(role) {
		return this._isForSameAgency(role);
	}

	//
	// canAttachOrDetachCompanyId
	//

	canCompanyIdBeAttachedOrDetachedByCountryUser() {
		return true;
	}

	canCompanyIdBeAttachedOrDetachedByDirector(role) {
		return this._isForSameAgency(role);
	}

	//
	// canEditUserInfo
	//

	canUserInfoBeEditedByCountryUser() {
		return true;
	}

	canUserInfoBeEditedByDirector(role) {
		return this._isForSameAgency(role);
	}

	//
	// canCreatePeriodReports
	//

	canCreatePeriodReports(company) {
		return this.canAdministrateCompanyId(company.getLegacyId());
	}

	canAdministrateCompanyId(companyId) {
		return this._companyIds.includes(companyId);
	}

	canAdministrateAllCompanyIds(otherCompanyIds) {
		return otherCompanyIds.every(this.canAdministrateCompanyId.bind(this));
	}

	canAdministrateAnyCompanyId(otherCompanyIds) {
		return otherCompanyIds.some(this.canAdministrateCompanyId.bind(this));
	}

	canViewBudgetEditor(company) {
		return this.canViewAccountingDocuments(company);
	}
}
